export default {"src":"/_next/static/media/equity.bc5648d7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};